/** Must match the header checked by lighthouse-backend activity tracking. */
export const DEV_HARNESS_SESSION_HEADER = 'X-Dev-Harness-Session'

/**
 * True when the product UI is on the Inbox Agent Dev Harness. Used to keep
 * harness usage out of last_active_at / user_activity_sessions metrics.
 */
export function isOnDevTestingRoute(): boolean {
    if (typeof window === 'undefined') return false
    return window.location.pathname.startsWith('/dev/testing')
}

/**
 * Headers to attach to authenticated product API calls while the tab is on
 * `/dev/testing`, so the backend can exclude those requests from activity
 * metrics (same idea as staff impersonation).
 */
export function getDevHarnessHeaders(): Record<string, string> {
    if (!isOnDevTestingRoute()) return {}
    return { [DEV_HARNESS_SESSION_HEADER]: '1' }
}
